import { BrandWordmark } from "../../../shared/BrandWordmark";
import "./brand-mark.css";

export function BrandMark({ light = false }: { light?: boolean }) {
  return (
    <BrandWordmark
      className={"locked-brand" + (light ? " locked-brand--light" : "")}
      typeClassName="locked-brand__type"
      sprigClassName="locked-brand__sprig"
      label="Life’s Capsule"
    />
  );
}
